import React, {Suspense} from 'react';
import Loading from "../../components/common/Loading";
import ServicePage from "../../components/sections/ServicePage";

const ErpSolutions = () => {
  return (
    <div>
      <Suspense fallback={<Loading />}>
        <ServicePage serviceKey={"desktop"}/>
      </Suspense>
    </div>
  );
};

export default ErpSolutions;
